 
                           
export function createXLSheetdata(clusterData) {
    clusterData.find((ticketDetails, index) => {
                
            clusterData[index].id=clusterData[index].id
            delete clusterData[index]['id']
                
            clusterData[index].ClusterName=clusterData[index].cluster_name
            delete clusterData[index]['cluster_name']

            clusterData[index].ClusterCode=clusterData[index].cluster_code
            delete clusterData[index]['cluster_code']
            
            clusterData[index].Manager=clusterData[index].manager_name
            delete clusterData[index]['manager_name']
            
            clusterData[index].City=clusterData[index].city_name
            delete clusterData[index]['city_name']
            
            
            clusterData[index].KitchenCode=clusterData[index].kitchen_code
            delete clusterData[index]['kitchen_code']
            
            clusterData[index].KitchenName=clusterData[index].kitchen_name
            delete clusterData[index]['kitchen_name']
            
            clusterData[index].KitchenManagerName=clusterData[index].kitchen_manager_name
            delete clusterData[index]['kitchen_manager_name']

            return false

            })   
            return clusterData
}



// WEBPACK FOOTER //
// ./src/modules/Clusters/services/helpers.js